import React, { useState, useEffect } from 'react';
import './styles/styletest.css'; 

const questions = [
  {
    question: "Co to jest React?",
    options: ["Biblioteka JavaScript", "Język programowania", "System operacyjny", "Edytor tekstu"],
    correctAnswer: 0
  },
  {
    question: "Który język jest używany do stylizacji stron internetowych?",
    options: ["HTML", "Python", "CSS", "Java"],
    correctAnswer: 2
  },
  {
    question: "Który z tych języków jest językiem backendowym?",
    options: ["HTML", "CSS", "JavaScript", "Python"],
    correctAnswer: 3
  },
  // Dodaj tutaj kolejne pytania
];

const TestINFtrojka = () => {
  const [userAnswers, setUserAnswers] = useState(Array(questions.length).fill(null));
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(60*60); // 60 minut w sekundach

  useEffect(() => {
    if (timeLeft > 0 && !showResults) {
      const timer = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (timeLeft === 0) {
      handleSubmit();
    }
  }, [timeLeft, showResults]);

  const handleAnswer = (questionIndex, optionIndex) => {
    const updatedAnswers = [...userAnswers];
    updatedAnswers[questionIndex] = optionIndex;
    setUserAnswers(updatedAnswers);
  };

  const handleSubmit = () => {
    let newScore = 0;
    userAnswers.forEach((answer, index) => {
      if (answer === questions[index].correctAnswer) {
        newScore += 1;
      }
    });
    setScore(newScore);
    setShowResults(true);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return (
    <div id="testinf03">
        <section className='naglowek'>
            <h1>Test Teoretyczny INF03 - 40 Pytań losowych</h1>
            <p>Przetestuj swoje umiejętności w warunkach identycznych z prawdziwym egzaminem!<br/>
                 Na rozwiązanie czterdziestu pytań w tej części pisemnej masz maksymalnie 60 minut. Powodzenia!</p>
        </section>
        <hr />
        <div className="timer">
          <p>Pozostały czas: {formatTime(timeLeft)}</p>
        </div>
        <hr />
      {questions.map((q, index) => (
        <div key={index} className="question-container">
          <h3 className="question-text">{q.question}</h3>
          {showResults && (
            <div>
              {userAnswers[index] === q.correctAnswer && (
                <p className="result-message correct">
                  Tak jest, Twoja odpowiedź: {String.fromCharCode(65 + userAnswers[index])} jest poprawna!
                </p>
              )}
              {userAnswers[index] !== q.correctAnswer && userAnswers[index] !== null && (
                <p className="result-message wrong">
                  Pomyłka! Poprawna odpowiedź to {String.fromCharCode(65 + q.correctAnswer)} (twoja odpowiedź: {String.fromCharCode(65 + userAnswers[index])})
                </p>
              )}
              {userAnswers[index] === null && (
                <p className="result-message missing">
                  Nie udzielono odpowiedzi! Poprawna odpowiedź to: {String.fromCharCode(65 + q.correctAnswer)}
                </p>
              )}
            </div>
          )}
          {q.options.map((option, i) => {
            const isCorrect = i === q.correctAnswer;
            const isUserAnswer = userAnswers[index] === i;
            let className = "answer-label";
            
            if (showResults) {
              if (isUserAnswer && !isCorrect) {
                className += " wrong-answer";
              } else if (isCorrect) {
                className += " correct-answer";
              } else if (!isUserAnswer) {
                className += " neutral-answer";
              }
            }
            return (
              <label key={i} className={className}>
                <input
                  type="radio"
                  name={`question-${index}`}
                  checked={userAnswers[index] === i}
                  onChange={() => handleAnswer(index, i)}
                  disabled={showResults}
                />
                <div className="radio-circle"></div>
                {String.fromCharCode(65 + i)}. {option}
              </label>
            );
          })}
          
        </div>
      ))}
      <hr />
        <div className="timer">
          <p>Pozostały czas: {formatTime(timeLeft)}</p>
        </div>
    <hr />
      <button onClick={handleSubmit} className='btn btn-primary'>Sprawdź Odpowiedzi</button>
      {showResults && (
        <div>
          <h2>Wynik: {score} / {questions.length}</h2>
          <h3>Poprawne odpowiedzi:</h3>
          <ul>
            {questions.map((q, index) => (
              <li key={index}>
                {q.question} - <span className="correct-answer">{q.options[q.correctAnswer]}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TestINFtrojka;